'use client'

import 'swiper/css'
import 'swiper/css/a11y'
import 'swiper/css/scrollbar'
import 'swiper/css/mousewheel'
import 'swiper/css/navigation'
import 'swiper/css/effect-fade'
import 'swiper/css/thumbs'

import { css, createGlobalStyle } from 'styled-components'

import { primaryFont, getFontClassName } from './fonts'
import { fontFaces } from './fontStyles'
const reset = css`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  /* Prevent font size inflation */
  html {
    -moz-text-size-adjust: none;
    -webkit-text-size-adjust: none;
    text-size-adjust: none;
  }

  /* Remove default margin in favour of better control in authored CSS */
  body, h1, h2, h3, h4, h5, h6, p,
  figure, blockquote, dl, dd {
    margin: 0;
  }

  /* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
  ul[role='list'],
  ol[role='list'] {
    list-style: none;
  }

  /* Set core body defaults */
  body {
    min-height: 100svh;
    line-height: 1.5;
  }

  /* Set shorter line heights on headings and interactive elements */
  h1, h2, h3, h4, h5, h6,
  button, input, label {
    line-height: 1.1;
  }

  /* Balance text wrapping on headings */
  h1, h2,
  h3, h4,
  h5, h6 {
    text-wrap: balance;
  }

  /* A elements that don't have a class get default styles */
  a:not([class]) {
    text-decoration-skip-ink: auto;
    color: currentColor;
  }

  /* Make images easier to work with */
  img,
  picture {
    max-width: 100%;
    display: block;
  }

  /* Inherit fonts for inputs and buttons */
  input, button,
  textarea, select {
    font: inherit;
  }

  /* Make sure textareas without a rows attribute are not tiny */
  textarea:not([rows]) {
    min-height: 10em;
  }

  /* Anything that has been anchored to should have extra scroll margin */
  :target {
    scroll-margin-block: 5ex;
  }

  .spinner-container {
    position: fixed;
    width: 100vw;
    height: 100vh;
    border: 0px;
    left: 0px;
    top: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 100;
  }

  .spinner-container.contained {
    width: 100%;
    height: 100%;
  }

  .spinner {
    width: 64px;
    height: 64px;
    animation: spin 1s linear infinite;
    border: 2px solid #FFFDFC;
    border-top: 2px solid #43B05E;
    border-radius: 50%;
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

const GlobalStyles = createGlobalStyle`
  ${reset}
  ${fontFaces}

  html {
    @media (min-width: 992px) and (max-width: 1143px) {
      font-size: 80%;
    }
  }

  body {
    font-family: ${process.env.STORYBOOK ? 'Everett' : 'inherit'};
    ${getFontClassName(primaryFont)}
  }
`

export default GlobalStyles
